/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCloudUsageBillingAggregation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCloudUsageBillingAggregation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCloudUsageBillingAggregation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCloudUsageBillingAggregation>): BackgroundJobPayloadForCloudUsageBillingAggregation {
        let obj = Object.assign(new BackgroundJobPayloadForCloudUsageBillingAggregation(), model);
        BackgroundJobPayloadForCloudUsageBillingAggregation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCloudUsageBillingAggregation>): BackgroundJobPayloadForCloudUsageBillingAggregation {
        if (!model) return null;
        return BackgroundJobPayloadForCloudUsageBillingAggregation.newInstance(<BackgroundJobPayloadForCloudUsageBillingAggregation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCloudUsageBillingAggregation) {
        if (!obj) return;

        models.BackgroundJobPayloadForCloudUsageBillingAggregation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCloudUsageBillingAggregation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCloudUsageBillingAggregation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Target Service Account Id
     */
    service_account_id: string;

    start_date: Date;

    end_date: Date;

    /**
     * Skip L1 to L1 Slim aggregation
     */
    skip_l1_to_l1_slim: boolean = false;

}
